import type { ReactNode } from 'react';

import { cn } from '../lib/cn';

export type DividerProps = {
  /** Libellé centré entre les deux traits (« Ou bien »). Sans enfant, trait simple. */
  children?: ReactNode;
  className?: string;
};

export function Divider({ children, className }: DividerProps) {
  if (!children) {
    return <hr className={cn('w-full border-brand-600/20', className)} />;
  }

  return (
    <div className={cn('flex w-full items-center gap-3', className)}>
      <span className="h-px flex-1 bg-brand-600/40" />
      <span className="text-xs text-content-muted">{children}</span>
      <span className="h-px flex-1 bg-brand-600/40" />
    </div>
  );
}
